import { numberValidator, plaintextValidator } from '../fields';
import { getTranslatedText } from '@nile/components';

const config = { mandatory: true };

export const validateSessionSettings = (intl) => {
  return {
    sessionInactiveDuration: numberValidator({
      mandatory: true,
      optional: {
        greaterThan: 0,
        notGreaterThan: getTranslatedText(
          intl,
          'admin.sessionSettings.sessionInactiveDuration.errorMessage'
        )
      }
    }),
    sessionInactiveUnit: plaintextValidator(config)
  };
};
